﻿export const events = {
    notifyFacilityUpdate: "notifyFacilityUpdate",
    notifyLockUpdate: "notifyLockUpdate",
    notifyUserUpdate: "notifyUserUpdate",
    notifyRoleUpdate: "notifyRoleUpdate",
    notifyImportFacilityProgress: "notifyImportFacilityProgress",
    notifyInvalidAddresses: "notifyInvalidAddresses"
}
